import { render, staticRenderFns } from "./MyQuizzesGameModal.vue?vue&type=template&id=490fe996&scoped=true&"
import script from "./MyQuizzesGameModal.vue?vue&type=script&lang=js&"
export * from "./MyQuizzesGameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490fe996",
  null
  
)

export default component.exports